import { httpPost } from "../../services/api";

export const sdkTokenizeReceipt = async ({
  receipt,
  methodId,
  cardTokenIntentId,
  publicApiKey,
}: {
  receipt: string;
  methodId: string;
  cardTokenIntentId: string;
  publicApiKey: string;
}) => {
  const { data } = await httpPost<{ data: { id: string } }>(
    `tokens/receipt/`,
    {
      receipt,
      method_id: methodId,
      card_token_intent_id: cardTokenIntentId,
    },
    false,
    {
      "x-public-key": publicApiKey,
    }
  );

  return data.id;
};
